var React = require('react');

function MapPin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M144 320a175.77 175.77 0 0 0 32-3.06v156.69l-22 33a12 12 0 0 1-20 0l-22-33V316.94a175.77 175.77 0 0 0 32 3.06z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M144 0a144 144 0 1 0 144 144A144 144 0 0 0 144 0zm0 76a68.07 68.07 0 0 0-68 68 12 12 0 0 1-24 0 92.11 92.11 0 0 1 92-92 12 12 0 0 1 0 24z","className":"fa-primary","key":2})]);
}

MapPin.defaultProps = {"viewBox":"0 0 288 512","className":"icon"};

module.exports = MapPin;

MapPin.default = MapPin;
